module.exports = __webpack_public_path__ + "static/media/bottom_banner_4_1.156038a7.png";